var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayViolet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9165 12.7498L12.7498 8.99984L6.9165 5.24984V12.7498ZM8.99984 17.3332C7.84706 17.3332 6.76373 17.1144 5.74984 16.6769C4.73595 16.2394 3.854 15.6457 3.104 14.8957C2.354 14.1457 1.76025 13.2637 1.32275 12.2498C0.885254 11.2359 0.666504 10.1526 0.666504 8.99984C0.666504 7.84706 0.885254 6.76373 1.32275 5.74984C1.76025 4.73595 2.354 3.854 3.104 3.104C3.854 2.354 4.73595 1.76025 5.74984 1.32275C6.76373 0.885254 7.84706 0.666504 8.99984 0.666504C10.1526 0.666504 11.2359 0.885254 12.2498 1.32275C13.2637 1.76025 14.1457 2.354 14.8957 3.104C15.6457 3.854 16.2394 4.73595 16.6769 5.74984C17.1144 6.76373 17.3332 7.84706 17.3332 8.99984C17.3332 10.1526 17.1144 11.2359 16.6769 12.2498C16.2394 13.2637 15.6457 14.1457 14.8957 14.8957C14.1457 15.6457 13.2637 16.2394 12.2498 16.6769C11.2359 17.1144 10.1526 17.3332 8.99984 17.3332Z",
    fill: "#440FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayViolet);
export default __webpack_public_path__ + "static/media/play-violet.127491c84db475a6c691718f9da1a16f.svg";
export { ForwardRef as ReactComponent };